import { useEffect, useState } from "react";
import api from "../../lib/api";
import { PageHeader, Loading } from "../../components/shared";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";

export default function AdminAudit() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/audit-logs").then((r) => setRows(r.data)); }, []);
  if (!rows) return <Loading />;
  return (
    <div>
      <PageHeader title="Audit Logs" subtitle="Immutable record of important platform actions." />
      <div className="bg-card border rounded-xl overflow-hidden overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Timestamp</TableHead><TableHead>User</TableHead><TableHead>Action</TableHead><TableHead>Entity</TableHead><TableHead>Entity ID</TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.map((a) => (
              <TableRow key={a.log_id}>
                <TableCell className="text-xs">{(a.timestamp || "").slice(0, 19).replace("T", " ")}</TableCell>
                <TableCell className="text-xs">{a.user_email}</TableCell>
                <TableCell className="capitalize text-sm font-medium">{a.action}</TableCell>
                <TableCell className="text-sm">{a.entity}</TableCell>
                <TableCell className="font-mono text-xs text-muted-foreground">{a.entity_id}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
